import { render } from "./RandevuMinorMain.vue?vue&type=template&id=90d69150&scoped=true"
import script from "./RandevuMinorMain.vue?vue&type=script&lang=js"
export * from "./RandevuMinorMain.vue?vue&type=script&lang=js"

import "./RandevuMinorMain.vue?vue&type=style&index=0&id=90d69150&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d69150"]])

export default __exports__